var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app-container" } },
    [
      _vm.showLoader()
        ? _c("rotate-loader", {
            attrs: {
              loading: _vm.getLoaderStatus,
              color: "#FF4400",
              size: "15px"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.getForceBindStatus
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-success alert-dismissible fade show password-success",
              attrs: { role: "alert" }
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getPasswordUpdateSuccess
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-success alert-dismissible fade show password-success",
              attrs: { role: "alert" }
            },
            [_vm._m(1)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.getUpdatedApp
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-warning alert-dismissible fade show system-warning",
              attrs: { role: "alert" }
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "col px-0 d-inline-block" }, [
                  _c("p", [
                    _vm._v(
                      "There's a newer version of this app. Please reload this page."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary mx-auto",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.reloadPage()
                        }
                      }
                    },
                    [_vm._v("\n          Reload\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Close"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.closeUpdatedApp()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.getNetworkStatus
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-danger alert-dismissible fade show system-danger",
              attrs: { role: "alert" }
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "col px-0 d-inline-block" }, [
                  _c("p", [
                    _c("strong", [_vm._v(_vm._s(_vm.getNetworkMessageStatus))])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "We're sorry, an error has occurred, and we are diligently working on a solution. If the error persists, please contact your system administrator."
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger mx-auto",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.closeNetWorkMessage()
                        }
                      }
                    },
                    [_vm._v("\n          Previous Screen\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "alert",
                      "aria-label": "Close"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.closeNetWorkMessage()
                      }
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", { key: _vm.$route.fullPath })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "d-inline-block float-left align-self-center mx-2 text-center"
        },
        [
          _c("img", {
            attrs: {
              width: "25px",
              height: "25px",
              src: require("./assets/check-circle-green.svg"),
              alt: "Success!"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col px-0 d-inline-block" }, [
        _c("p", [_c("strong", [_vm._v("Policy Bind Successful!")])]),
        _vm._v(" "),
        _c("p", [_vm._v("Your policy has been closed and bound.")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "d-inline-block float-left align-self-center mx-2 text-center"
        },
        [
          _c("img", {
            attrs: {
              width: "25px",
              height: "25px",
              src: require("./assets/check-circle-green.svg"),
              alt: "Success!"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col px-0 d-inline-block" }, [
        _c("p", [
          _c("strong", [_vm._v("Success! - Your Password Has Been Updated")])
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Please remember your new password for the next time you log in."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-inline-block float-left align-self-center mx-2 text-center"
      },
      [
        _c("img", {
          attrs: {
            width: "25px",
            height: "25px",
            src: require("./assets/info-circle-yellow.svg"),
            alt: "Info!"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-inline-block float-left align-self-center mx-2 text-center"
      },
      [
        _c("img", {
          attrs: {
            width: "25px",
            height: "25px",
            src: require("./assets/times-circle-red.svg"),
            alt: "Alert!"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b27ca68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b27ca68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/App.vue
// module id = null
// module chunks = 